import { Dialog, DialogActions, DialogContent } from "@mui/material";
import React from "react";
import ButtonPolicy from "./Permission/ButtonPolicy";

const DailogContainer = ({
  detailOpen,
  setDetailOpen,
  text,
  onToggleChange,
}) => {
  const handleCloseDeleteDetail = () => {
    setDetailOpen(false);
  };

  return (
    <Dialog open={detailOpen} onClose={handleCloseDeleteDetail}>
      <DialogContent className="viewCard">
        <div>{text}</div>
      </DialogContent>
      <DialogActions className="viewCard">
        <ButtonPolicy className="closeButtonCustomDialouge" onClick={handleCloseDeleteDetail}>close</ButtonPolicy>
        <ButtonPolicy className="confirmButtonCustomDialouge" onClick={() => onToggleChange()}>
          Confirm
        </ButtonPolicy>
      </DialogActions>
    </Dialog>
  );
};

export default DailogContainer;
